// extracted by mini-css-extract-plugin
module.exports = {"container":"article-module--container--1OyUF","bibleBookBody":"article-module--bibleBookBody--1HHwY"};